import { Fragment } from 'react';
import { splitHighlight } from '../../shared/highlight-match';

type Props = {
  /** Anzuzeigender Text (Dateiname / Stack-Label). */
  text: string;
  /**
   * Roher `?q=`-Suchstring (String-Primitive!). Leer/undefined → Plain-Text,
   * kein `<mark>`-DOM. Bewusst der ROHE Query, NICHT ein abgeleitetes Token-
   * Array: an die memoisierten Card/Row-Komponenten geht so ein Primitive durch
   * → kein memo-Break (Session-23-Scroll-Storm, `patterns/react.md`). Die
   * Token-/Segment-Berechnung passiert hier unten, pro Instanz, billig.
   */
  query?: string;
};

/**
 * Rendert `text` mit hervorgehobenen Query-Treffern. Matched-Segmente in
 * `<mark>` mit dezentem Brand-Styling (weicher gelber Marker, `text-inherit`
 * hält die Dateiname-Farbe — kein UA-Default-Schwarz/Knallgelb). Ohne Query
 * oder ohne literalen Treffer fällt sie auf Plain-Text zurück (kein Mark-DOM).
 */
export function HighlightedText({ text, query }: Props) {
  if (!query) return <>{text}</>;

  const segments = splitHighlight(text, query);
  // Kein literaler Treffer (z.B. reiner Fuzzy-/Tippfehler-Match) → Plain-Text.
  if (segments.length === 1 && !segments[0].match) return <>{text}</>;

  return (
    <>
      {segments.map((seg, i) =>
        seg.match ? (
          <mark
            key={i}
            className="rounded-sm bg-brand-yellow/40 px-0.5 text-inherit"
          >
            {seg.text}
          </mark>
        ) : (
          <Fragment key={i}>{seg.text}</Fragment>
        ),
      )}
    </>
  );
}
